import { Icon } from '@chakra-ui/react';

/** Lightbulb icon from stamp-card inspiration assets (gradient fill). */
export const CustomLightbulbIcon = (props) => {
  const { color, width = 13, height = 16, ...rest } = props || {};
  const strokeMain = color ? 'currentColor' : 'url(#paint0_linear_stamp_card_inspiration)';
  const strokeSecondary = color
    ? 'currentColor'
    : 'url(#paint1_linear_stamp_card_inspiration)';

  return (
    <Icon
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 13 16"
      fill="none"
      color={color}
      {...rest}
    >
      <path
        d="M4.41744 13.0007C4.41744 12.5009 4.41744 12.2517 4.38884 12.0858C4.29938 11.5517 4.28398 11.5174 3.92684 11.0974C3.81538 10.9665 3.40471 10.6158 2.58338 9.91305C1.75316 9.20426 1.16796 8.27156 0.905214 7.23836C0.642468 6.20515 0.714558 5.12015 1.11194 4.12692C1.50933 3.13368 2.21329 2.27902 3.13066 1.67602C4.04804 1.07302 5.1356 0.750106 6.24945 0.75C7.3633 0.749894 8.45093 1.0726 9.36843 1.67543C10.2859 2.27825 10.9901 3.13278 11.3877 4.12594C11.7853 5.1191 11.8576 6.20408 11.595 7.23733C11.3325 8.27059 10.7475 9.2034 9.91744 9.91235C9.09538 10.6151 8.68471 10.9665 8.57398 11.0967C8.21684 11.5167 8.20144 11.551 8.11124 12.0851C8.08338 12.251 8.08338 12.5009 8.08338 13H4.41671C4.41671 13.6545 4.41671 13.9814 4.56411 14.225C4.66065 14.3846 4.7995 14.5171 4.96671 14.6093C5.22191 14.75 5.56438 14.75 6.25004 14.75C6.93571 14.75 7.27818 14.75 7.53411 14.61C7.70132 14.5178 7.84017 14.3853 7.93671 14.2257C8.08411 13.9821 8.08411 13.6552 8.08411 13.0007"
        stroke={strokeMain}
        strokeWidth="1.5"
      />
      <path
        d="M6.25011 11.2504V9.85038M6.25011 9.85038C6.50755 9.85038 6.76046 9.78564 6.98341 9.66278C7.20637 9.53991 7.39152 9.3632 7.52025 9.15039M6.25011 9.85038C5.99267 9.85038 5.73977 9.78564 5.51681 9.66278C5.29386 9.53991 5.10871 9.3632 4.97998 9.15039"
        stroke={strokeSecondary}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      {!color && (
        <defs>
          <linearGradient
            id="paint0_linear_stamp_card_inspiration"
            x1="6.25"
            y1="0.75"
            x2="6.25"
            y2="14.75"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.164982" stopColor="#FF9554" />
            <stop offset="1" stopColor="#FF4935" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_stamp_card_inspiration"
            x1="6.25011"
            y1="9.15039"
            x2="6.25011"
            y2="11.2504"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.164982" stopColor="#FF9554" />
            <stop offset="1" stopColor="#FF4935" />
          </linearGradient>
        </defs>
      )}
    </Icon>
  );
};
